import { makeAutoObservable, runInAction } from 'mobx';

import { RolesApi } from './roles.api';
import { CreateRoleRequestDto, RoleDto, UpdateRoleRequestDto } from './roles.dto';

class RolesStore {
  rolesApi: RolesApi;

  isLoading = false;

  roles: RoleDto[];

  constructor() {
    this.rolesApi = new RolesApi();
    this.roles = [];

    makeAutoObservable(this, {}, { autoBind: true });
  }

  public async getAllRoles() {
    this.isLoading = true;

    try {
      const response = await this.rolesApi.getAllRoles();

      runInAction(() => {
        this.roles = response;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  public async createRole(roleDto: CreateRoleRequestDto) {
    this.isLoading = true;

    try {
      await this.rolesApi.createRole(roleDto);
      await this.getAllRoles();
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  public async updateRole(id: number, roleDto: UpdateRoleRequestDto) {
    this.isLoading = true;

    try {
      await this.rolesApi.updateRole(id, roleDto);
      await this.getAllRoles();
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  public async deleteRole(id: number) {
    this.isLoading = true;

    try {
      await this.rolesApi.deleteRole(id);
      await this.getAllRoles();
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}

export default RolesStore;
